import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useWindowSize } from '@react-hook/window-size';

import routes from './routes';

import { registerProfileActivity } from './actions/Profile/ProfileActions';

import LoadingScreen from './components/LoadingScreen';

import { Breakpoints } from './assets/Variables.style';

toast.configure({
  hideProgressBar: true,
  position: 'bottom-right',
});

const System = () => {
  const [width] = useWindowSize();
  const firebaseStore = useSelector((state) => state.firebase);
  const { auth, profile } = firebaseStore;
  const dispatch = useDispatch();

  const checkProfileActivity = () => {
    if (
      profile &&
      (!profile.loggedIn ||
        (profile.loggedIn && moment().diff(profile.loggedIn, 'minutes') >= 15))
    )
      dispatch(registerProfileActivity());
  };

  useEffect(() => {
    let timerID;
    if (
      auth &&
      auth.isLoaded &&
      profile &&
      profile.isLoaded &&
      !auth.isEmpty &&
      !profile.isEmpty
    )
      timerID = setInterval(() => checkProfileActivity(), 1000);
    return () => {
      if (timerID) clearInterval(timerID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoaded, profile.isLoaded, profile.loggedIn]);

  return (
    <>
      {auth && auth.isLoaded && profile && profile.isLoaded ? (
        <Switch>
          {routes
            .filter(
              (route) =>
                (route.isAuth === undefined ||
                  route.isAuth === !auth.isEmpty) &&
                (!route.isHiddenOnMobile ||
                  (route.isHiddenOnMobile && width > Breakpoints.lg))
            )
            .map((route, key) => (
              <Route
                key={key}
                path={route.path}
                name={route.name}
                exact={route.isExact}
                component={route.component}
              />
            ))}
        </Switch>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
};

export default System;
